import React from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag, I18nText } from '@welldev-group/react-comp-lib';
import {
  ENTERPRISE,
  FREE,
  LITE,
  GROWTH,
  CUSTOM,
} from '../../../../shared/helper/plans';

const getPlanWithSubcriptionPeriod = (plan, subscriptionPeriod) => {
  if (plan) {
    return (
      <I18nText
        id={`affiliate_three_sixty.affiliate.tabs.plans.${plan}_${subscriptionPeriod}`}
      />
    );
  }
  return '';
};

const PlanEmphasisTag = ({ plan, subscriptionPeriod }) => {
  let type;
  const planWithSubcriptionPeriod = getPlanWithSubcriptionPeriod(
    plan,
    subscriptionPeriod,
  );

  switch (plan) {
    case FREE:
      type = 'neutral';
      break;
    case LITE:
      type = null;
      break;
    case GROWTH:
      type = 'accent';
      break;
    case ENTERPRISE:
      type = 'important';
      break;
    case CUSTOM:
      type = 'warning';
      break;
    default:
      type = null;
  }
  return (
    <EmphasisTag type={type} text={planWithSubcriptionPeriod} size="small" />
  );
};
PlanEmphasisTag.propTypes = {
  plan: PropTypes.string.isRequired,
  subscriptionPeriod: PropTypes.string.isRequired,
};

export default PlanEmphasisTag;
